/**
 * Layout component that queries for data
 * with Gatsby's useStaticQuery component
 *
 * See: https://www.gatsbyjs.org/docs/use-static-query/
 */

import React from "react";
import PropTypes from "prop-types";
import { useStaticQuery, graphql } from "gatsby";
import styled from "styled-components";
import SiteMargins from "./SiteMargins";
import Header from "./header";
import Spacing from "../components/Spacing";

const Footer = styled.footer`
  max-width: 500px;
`;

const Layout = ({ children }) => {
  const data = useStaticQuery(graphql`
    query SiteTitleQuery {
      site {
        siteMetadata {
          title
        }
      }
    }
  `);

  return (
    <>
      <Header siteTitle={data.site.siteMetadata.title} />
      <SiteMargins>
        <main>{children}</main>
        <Spacing height={5} />
        <Footer>
          © {new Date().getFullYear()}
          {` `}
          Nathan Vogel - I'm an interaction designer and developer based in
          Switzerland. Need help on a project?{" "}
          <a href="https://nathanvogel.com">Contact me!</a>
        </Footer>
        <Spacing height={8} />
      </SiteMargins>
    </>
  );
};

Layout.propTypes = {
  children: PropTypes.node.isRequired,
};

export default Layout;
